// extracted by mini-css-extract-plugin
module.exports = {"root":"Static_root__z4Vf_","list":"Static_list__6Dsck","popup":"Static_popup__GuBnu","menu":"Static_menu__WZuIz","fadeIn":"Static_fadeIn__66ohb","spin":"Static_spin__J7Kbm"};